import { createStore } from 'effector';

const initFilters = {
  city: 2,
  residential_complex: [],
  from_owner: false,
  mortgage: false,
  tour_3d: false,
  rooms: [],
  cost_from: null,
  cost_to: null,
  renovation_level: [],
  house_type: [],
  square_from: null,
  square_to: null,
  year_from: null,
  year_to: null,
  first_floor: false,
  districts: [],
};

export const $centerHomeFilters = createStore(initFilters);
$centerHomeFilters.watch((state) => console.log('$centerHomeFilters', state));

export const $chHexagons = createStore([]);
$chHexagons.watch((state) => console.log('$chHexagons', state));
export const $chStartHexagons = createStore([]);
$chStartHexagons.watch((state) => console.log('$chStartHexagons', state));

export const $chPoints = createStore([]);
export const $chStartPoints = createStore([]);
$chPoints.watch((state) => console.log('$chPoints', state));

export const $hexProp = createStore('room1_hex_mean');

export const $priceType = createStore('meter');
$priceType.watch((state) => console.log('$priceType', state));

export const $mobilePopup = createStore(null);

export const $chQuery = createStore(window.location.search);

export const $chComplexes = createStore([]);

export const $chCities = createStore([]);

export const $chDistricts = createStore([]);

export const $loading = createStore(false);
